import { DownloadSimpleIcon } from '@phosphor-icons/react'
import { Server } from '../../../../../api/Server'
import { useSelector } from 'react-redux'
import { ScoopText, ScoopStatusBubble, ScoopRow, ScoopColumn, ScoopButton } from '../../../../ui'
import styles from './BotDrawerInfo.module.scss'

export const BotDrawerInfo = ({ logDetails, dataset }) => {
    const userID = useSelector((state) => state.auth.userID)
    const workspaceID = useSelector((state) => state.auth.workspaceID)
    const token = useSelector((state) => state.auth.token)

    // messaging depends on whether this is a real bot or file upload which isn't a real bot but classified as one
    const successSteps = dataset.botService
        ? [
              { step: 'Bot accessed report', status: 'Success' },
              { step: 'Data found in report', status: 'Success' },
              { step: 'Data successfully processed', status: 'Success' },
          ]
        : [
              { step: 'Found report', status: 'Success' },
              { step: 'Data found in report', status: 'Success' },
              { step: 'Data successfully processed', status: 'Success' },
          ]

    const failureSteps = dataset.botService
        ? [{ step: "Bot Couldn't access report", status: 'Failed' }]
        : [
              {
                  step: "We couldn't access report in the file you uploaded",
                  status: 'Failed',
              },
          ]

    const actionableAdvice = dataset.botService
        ? 'Configure Dataset for the Scoop Data Connector to access a proper report.'
        : 'Try uploading a different CSV or Zip file with a table containing data.'

    const processSourceContent = (result) => {
        const resultUrl = result?.url ? result.url : result
        const cleanedUrl = resultUrl.replace(/\s+/g, '')
        window.open(cleanedUrl)
    }

    const failMessage = dataset.botService
        ? "It looks like the bot couldn't access this report. Try reconfiguring this dataset and rerunning this scoop."
        : 'The file you uploaded did not contain a valid table that Scoop could work with.'

    const handleSourceContent = (inboxID, s3Key) => {
        const server = new Server(workspaceID, userID, token)
        server.postData(
            {
                action: 'getIngestionContent',
                inboxID: inboxID,
                s3Key: s3Key,
            },
            processSourceContent
        )
    }

    return (
        <>
            <ScoopColumn>
                <ScoopText className={styles.sectionTitle}>Source Info</ScoopText>

                <ScoopRow className={styles.sourceInfoContainer}>
                    <ScoopColumn>
                        <ScoopRow className={styles.infoRow}>
                            <ScoopText className={styles.infoLabel}>Report</ScoopText>
                            <ScoopText className={styles.infoValue}>
                                {logDetails.contentKey}
                            </ScoopText>
                        </ScoopRow>
                    </ScoopColumn>
                    <ScoopButton
                        variant="text"
                        size="xxs"
                        className={styles.downloadButton}
                        onClick={() => {
                            handleSourceContent(logDetails.inboxID, logDetails.s3key)
                        }}
                    >
                        <DownloadSimpleIcon size={20} />
                    </ScoopButton>
                </ScoopRow>
            </ScoopColumn>

            <ScoopColumn>
                <ScoopText className={styles.sectionTitle}>Scoop Activity</ScoopText>
                {logDetails?.rstiKey ? (
                    successSteps?.map((step, index) => (
                        <ScoopColumn key={index}>
                            <ScoopRow className={styles.activityStepContainer}>
                                <ScoopStatusBubble status={step.status} />
                                <ScoopText>{step.step}</ScoopText>
                            </ScoopRow>
                            {index !== successSteps?.length - 1 && (
                                <div className={styles.connectorLine} />
                            )}
                        </ScoopColumn>
                    ))
                ) : (
                    <>
                        {failureSteps?.map((step, index) => (
                            <ScoopColumn key={index}>
                                <ScoopRow className={styles.activityStepContainer}>
                                    <ScoopStatusBubble status={step.status} />
                                    <ScoopText>{step.step}</ScoopText>
                                </ScoopRow>
                                {index !== failureSteps?.length - 1 && (
                                    <div className={styles.connectorLine} />
                                )}
                            </ScoopColumn>
                        ))}
                        <div className={styles.errorMessageContainer}>
                            <ScoopText className={styles.failMessageText}>{failMessage}</ScoopText>
                            <ScoopText className={styles.actionableAdviceText}>
                                {actionableAdvice}
                            </ScoopText>
                        </div>
                    </>
                )}
            </ScoopColumn>
        </>
    )
}
